import { ClientLabelWithId } from '../../../../entities/ClientLabel'

export const mapLabelNamesToIds = (
	labelNames: string[],
	clientLabels: ClientLabelWithId[]
) => labelNames.reduce(
	(acc: string[], labelName) => {
		const label = clientLabels.find((clientLabel) => {
			return clientLabel.labelName === labelName
		})
		if (label) acc.push(label.labelId)
		return acc
	},
	[]
)
